<script>
export default {
}
</script>

<template>
  <div>
    <h5 class="measurement-title mb-0"> {{$t('dashboard_new_evollu.parameters.audiology')}} </h5>
    <span class="measurement-timestamp"> {{$t('checkup_plus.reports.measurements.last_measurement_date', {date: "29/12/2023 10:40"})}} </span>

    <table class="w-100">
      <colgroup>
        <col span="1" style="width: 30%">
      </colgroup>
      <tr>
        <td>
          <div class="measurement-card h-100">
            <div class="title-container d-flex align-items-center mb-3">
              <img style="margin-right: 10px" src="~@/assets/check-up-reports/evollu-default/left_ear.svg">
              <div>
                <h5 class="card-title">{{ $t('checkup_plus.reports.measurements.audiology.left_ear') }}</h5>
              </div>
            </div>
            <span class="card-title">
              40dB
            </span>
            <br>
            <span class="card-description">
              <span style="font-weight: bold">35dB</span> on the last measurement
            </span>
          </div>
        </td>
        <td>
          <div class="measurement-card h-100">
            <div class="title-container d-flex align-items-center mb-3">
              <img style="margin-right: 10px" src="~@/assets/check-up-reports/evollu-default/right_ear.svg">
              <div>
                <h5 class="card-title">{{ $t('checkup_plus.reports.measurements.audiology.right_ear') }}</h5>
              </div>
            </div>
            <span class="card-title">
              99dB
            </span>
            <br>
            <span class="card-description">
              <span style="font-weight: bold">20dB</span> on the last measurement
            </span>
          </div>
        </td>
        <td rowspan="2">
          <div class="measurement-card h-100">
            <div class="title-container d-flex align-items-center mb-3">
              <img style="margin-right: 10px" src="~@/assets/check-up-reports/evollu-default/info_circle.svg">
              <div>
                <h5 class="card-title">{{ $t('checkup_plus.reports.patient_overall_summary.recommendation') }}</h5>
              </div>
            </div>
            <span class="card-text-normal">
              Lorem ipsum dolor sit amet consectetur. Dolor sit sit proin in cras. Condimentum fames dui mauris amet quis tortor pulvinar in. In dolor euismod lobortis in tortor aliquet arcu hendrerit. Urna enim et euismod interdum blandit lorem. Rhoncus rutrum vitae justo euismod ullamcorper.Quam tellus arcu facilisis sollicitudin amet egestas aliquet. Ultrices nec et cursus platea. Tellus non aenean euismod aenean. Et neque eget sit turpis ut.
            </span>
          </div>
        </td>
      </tr>
      <tr>
        <td colspan="2">
          <div class="measurement-card h-100 d-flex justify--space-between">
            <div class="title-container d-flex align-items-center">
              <img style="margin-right: 10px" src="~@/assets/check-up-reports/evollu-default/warning_yellow.svg">
              <div>
                <h5 class="card-title">{{ $t('checkup_plus.reports.measurements.result') }}</h5>
              </div>
            </div>
            <span class="measurement-result-bad">
              Fever
            </span>
          </div>
        </td>
      </tr>
    </table>
  </div>
</template>

<style scoped lang="scss">
.measurement-card {
  padding: 20px;
  width: 100%;
  border: 1px solid lightgrey;
  border-radius: 15px;
  margin-bottom: 0;
}

table {
  width: 100%;
  height: 100%;
  table-layout: fixed;
}

td {
  height: 100%;
}

table td {
  padding-bottom: 10px;
}

table tr {
  margin-bottom: 10px;
}

table td:not(:first-child) {
  padding-left: 12px;
}

</style>
